import React, { useState } from 'react'
import { Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material'
import { Item } from '../../../common/snippets'
import { Box } from '@mui/system'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { detailColumnsStyles, jsPdfHeaderFooter, pdfHeaderColumn, DetailsDrawCell, excelHeader, excelHeaderTwo } from './constants'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { useSelector } from 'react-redux'
import moment from 'moment'
import * as id from '../reportId'
import { focusElemnt, navigation3 } from '../../../common/helper'

const FranchiseOutstandingReportTable = (props) => {
  const { headerData, tablesData, sourceBranch ,UseToPayAsCOD} = props
  const theme = useTheme()
  const { tableHeaderColor } = theme

  const { loginData } = useSelector((state) => state?.common)

  const [searchResult, setSearchResult] = useState(true)
  const [largePDF, setLargePDF] = useState(false)
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })

  const { generatePDF, load } = { ...state }
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')

  const groupedData = tablesData.reduce((acc, item) => {
    if (!acc[item.BranchName]) acc[item.BranchName] = []
    acc[item.BranchName].push(item)
    return acc
  }, {})

  const formattedData = []
  const grandTotal = {
    SN: 'GROSS AMOUNT',
    isTotal: true,
    GrossAmount: 0,
    GST: 0,
    TotalFreight: 0,
    FreightPercentage: 0,
    NetFreight: 0,
    TotalToPayBookings: 0,
    TotalToPayDeliveries: 0,
    TotalAmount: 0,
  }

  let serialNumber = 1

  Object.keys(groupedData).forEach((branch) => {
    formattedData.push({
      isSubHeading: true,
      SN: `Franchisee: ${branch}`,
    })

    groupedData[branch].forEach((item) => {
      formattedData.push({ ...item, SN: serialNumber++, isDataRow: true })
    })

    const branchTotal = {
      SN: 'TOTAL AMOUNT',
      isTotal: true,
      GrossAmount: groupedData[branch].reduce((sum, item) => sum + item.GrossAmount, 0),
      GST: groupedData[branch].reduce((sum, item) => sum + item.GST, 0),
      TotalFreight: groupedData[branch].reduce((sum, item) => sum + item.TotalFreight, 0),
      FreightPercentage: groupedData[branch].reduce((sum, item) => sum + item.FreightPercentage, 0),
      NetFreight: groupedData[branch].reduce((sum, item) => sum + item.NetFreight, 0),
      TotalToPayBookings: groupedData[branch].reduce((sum, item) => sum + item.TotalToPayBookings, 0),
      TotalToPayDeliveries: groupedData[branch].reduce((sum, item) => sum + item.TotalToPayDeliveries, 0),
      TotalAmount: groupedData[branch].reduce((sum, item) => sum + item.TotalAmount, 0),
    }

    formattedData.push(branchTotal)

    grandTotal.GrossAmount += branchTotal.GrossAmount
    grandTotal.GST += branchTotal.GST
    grandTotal.TotalFreight += branchTotal.TotalFreight
    grandTotal.FreightPercentage += branchTotal.FreightPercentage
    grandTotal.NetFreight += branchTotal.NetFreight
    grandTotal.TotalToPayBookings += branchTotal.TotalToPayBookings
    grandTotal.TotalToPayDeliveries += branchTotal.TotalToPayDeliveries
    grandTotal.TotalAmount += branchTotal.TotalAmount
  })

  formattedData.push(grandTotal)

  const PDFHeaderColumns = [
    { headerName: 'S/N', exportHead: 'S/N', field: 'SN', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left' },
    {
      headerName: 'Payment Type',
      exportHead: 'Payment Type',
      field: 'PaymentType',
      xlCol: { dataType: 'string', dataFormatter: null },
      align: 'left',
    },
    {
      headerName: 'Gross Amount',
      exportHead: 'Gross Amount',
      field: 'GrossAmount',
      xlCol: { dataType: 'number', dataFormatter: null },
      align: 'right',
    },
    { headerName: 'GST', exportHead: 'GST', field: 'GST', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right' },
    {
      headerName: 'Total Freight',
      exportHead: 'Total Freight',
      field: 'TotalFreight',
      xlCol: { dataType: 'number', dataFormatter: null },
      align: 'right',
    },
    {
      headerName: 'Comm. On Freight',
      exportHead: 'Comm. On Freight',
      field: 'FreightPercentage',
      xlCol: { dataType: 'number', dataFormatter: null },
      align: 'right',
    },
    {
      headerName: 'Net Freight',
      exportHead: 'Net Freight',
      field: 'NetFreight',
      xlCol: { dataType: 'number', dataFormatter: null },
      align: 'right',
    },
    {
      headerName: 'Total Topay Bookings',
      exportHead: 'Total Topay Bookings',
      field: 'TotalToPayBookings',
      xlCol: { dataType: 'number', dataFormatter: null },
      align: 'right',
    },
    {
      headerName: 'Total Topay Deliveries',
      exportHead: 'Total Topay Deliveries',
      field: 'TotalToPayDeliveries',
      xlCol: { dataType: 'number', dataFormatter: null },
      align: 'right',
    },
    {
      headerName: 'Total Amount',
      exportHead: 'Total Amount',
      field: 'TotalAmount',
      xlCol: { dataType: 'number', dataFormatter: null },
      align: 'right',
    },
  ]
  const updatedPDFHeaderColumns = (PDFHeaderColumns || []).map((col) => {
    if (UseToPayAsCOD === 1) {
      switch (col.field) {
        case 'TotalToPayBookings':
          return { ...col, headerName: 'Total COD Bookings', exportHead: 'Total COD Bookings' };
        case 'TotalToPayDeliveries':
          return { ...col, headerName: 'Total COD Deliveries', exportHead: 'Total COD Deliveries' };
        default:
          return col;
      }
    }
    return col;
  });
  const printClick = (isSave) => {
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumns = pdfHeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfColumns = updatedPDFHeaderColumns.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Franchise Outstanding Reports.pdf`,
      subject: 'Franchise Outstanding Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: [headerData],
      columnStyles: {
        0: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        1: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        2: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        3: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        4: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        5: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        6: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        7: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
      },
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
      },
    })

    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'top',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0],
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: formattedData,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2],
      },
      theme: 'grid',
      columnStyles: detailColumnsStyles,
      didParseCell: (data) => {
        DetailsDrawCell(data)
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System |  Franchise Outstanding Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Franchise Outstanding Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('gbDetailsOutput').data = pdfUrl
        // document.getElementById('gbDetailsOutput').data = doc.output('datauristring', ' Franchise Outstanding Reports.pdf')
        focusElemnt('backBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('gbDetailsOutput').data = pdfUrl
        // document.getElementById('gbDetailsOutput').data = doc.output('datauristring', ' Franchise Outstanding Reports.pdf')
        focusElemnt('backBtn')
      }, 2000)
    }
  }
  const InsideRowContent = ({ item, index, fs = '12px' }) => {
    return (
      <TableRow className="receivedTr" key={index}>
        {item?.isSubHeading ? (
          <TableCell
            className="userwiseTD"
            colSpan={10}
            style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', backgroundColor: tableHeaderColor?.isSubHeadingColor }}
          >
            {item.SN}
          </TableCell>
        ) : item?.isTotal ? (
          <>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={2}
              style={{
                padding: '8px 9px',
                textAlign: 'left',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: fs,
              }}
            >
              {item.SN}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={1}
              style={{
                padding: '8px 9px',
                textAlign: 'right',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: fs,
              }}
            >
              {item.GrossAmount}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={1}
              style={{
                padding: '8px 9px',
                textAlign: 'right',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: fs,
              }}
            >
              {item.GST}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={1}
              style={{
                padding: '8px 9px',
                textAlign: 'right',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: fs,
              }}
            >
              {item.TotalFreight}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={1}
              style={{
                padding: '8px 9px',
                textAlign: 'right',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: fs,
              }}
            >
              {item.FreightPercentage}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={1}
              style={{
                padding: '8px 9px',
                textAlign: 'right',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: fs,
              }}
            >
              {item.NetFreight}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={1}
              style={{
                padding: '8px 9px',
                textAlign: 'right',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: fs,
              }}
            >
              {item.TotalToPayBookings}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={1}
              style={{
                padding: '8px 9px',
                textAlign: 'right',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: fs,
              }}
            >
              {item.TotalToPayDeliveries}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={1}
              style={{
                padding: '8px 9px',
                textAlign: 'right',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: fs,
              }}
            >
              <span style={{ color: '#0086FF' }}>{item.TotalAmount}</span>
            </TableCell>
          </>
        ) : (
          <>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', maxWidth: '10px', fontSize: fs }}
            >
              {item.SN}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', maxWidth: '90px', fontSize: fs }}
            >
              {item.PaymentType}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', maxWidth: '10px', fontSize: fs }}
            >
              {item.GrossAmount}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', maxWidth: '10px', fontSize: fs }}
            >
              {item.GST}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', maxWidth: '10px', fontSize: fs }}
            >
              {item.TotalFreight}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', maxWidth: '10px', fontSize: fs }}
            >
              {item.FreightPercentage}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', maxWidth: '10px', fontSize: fs }}
            >
              {item.NetFreight}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', maxWidth: '10px', fontSize: fs }}
            >
              {item.TotalToPayBookings}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', maxWidth: '10px', fontSize: fs }}
            >
              {item.TotalToPayDeliveries}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', maxWidth: '10px', fontSize: fs }}
            >
              <span style={{ color: '#0086FF' }}>{item.TotalAmount}</span>
            </TableCell>
          </>
        )}
      </TableRow>
    )
  }
  return (
    <>
      <Stack style={{ margin: '0px 10px', marginRight: '0px' }}>
        <Item className="userReport">
          <Item className="userReport-heading">Report For: Franchise Outstanding Report</Item>
          <Item className="userReport-buttons">
            {searchResult ? (
              <>
                <Box onKeyDown={(e) => navigation3(e, 'ExportToPdf', id.reportmainButton, () => {})}>
                  <ReactHtmlTableToExcel
                    id="ExportToExl"
                    className="userWisereporttemExcelBtn"
                    table="table-gbDetailsTableReport-xls"
                    filename={`Franchise Outstanding Report ${currentDateTime}`}
                    sheet="tablexls"
                    buttonText="Export to Excel"
                  />
                </Box>
                <Box>
                  <Button
                    variant="outlined"
                    className="userWisereporttembtn"
                    id="ExportToPdf"
                    onClick={() => {
                      setSearchResult(false)
                      printClick(true)
                    }}
                    onKeyDown={(e) =>
                      navigation3(e, 'PrintBtn', 'ExportToExl', () => {
                        setSearchResult(false)
                        printClick(true)
                      })
                    }
                  >
                    Export to Pdf
                  </Button>
                </Box>
                <Box>
                  <Button
                    variant="outlined"
                    id="PrintBtn"
                    className="userWisereporttembtn"
                    onClick={() => {
                      setSearchResult(false)
                      printClick(false)
                    }}
                    onKeyDown={(e) =>
                      navigation3(e, id.fromDate, 'ExportToPdf', () => {
                        setSearchResult(true)
                        printClick(false)
                      })
                    }
                  >
                    Print
                  </Button>
                </Box>
              </>
            ) : (
              <>
                <Box>
                  <Button
                    variant="outlined"
                    id="backBtn"
                    className="userWisereporttembtn"
                    onClick={() => {
                      setSearchResult(true)
                    }}
                    onKeyDown={(e) =>
                      navigation3(e, id.fromDate, id.reportmainButton, () => {
                        setSearchResult(true)
                        setLargePDF(false)
                        focusElemnt(id.reportmainButton)
                      })
                    }
                  >
                    Back
                  </Button>
                </Box>
              </>
            )}
          </Item>
        </Item>
      </Stack>
      {searchResult ? (
        <Stack sx={{ marginLeft: 2, marginRight: 1, height: 470 }} className="scroll">
          <TableContainer
            className="lr-popup-table lrModel "
            component={Paper}
            style={{ borderRadius: '6px', border: '1px solid #aeaeae' }}
          >
            <>
              <Table size="small" aria-label="a dense table">
                <TableHead style={{ position: `sticky`, top: `0`, background: `white`, borderRadius: '10px 10px 10px 10px' }}>
                  <TableRow className="sammary-heading" style={{ borderRadius: '10px 10px 10px 10px' }}>
                    {updatedPDFHeaderColumns?.map((item, i) => (
                      <TableCell
                        className="userWiseReportHeading"
                        key={i}
                        style={{
                          textAlign: item.align,
                          verticalAlign: 'top',
                          color: tableHeaderColor.textColor,
                          backgroundColor: tableHeaderColor.isHeadingColor,
                          whiteSpace: 'pre-line',
                        }}
                      >
                        {item?.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {formattedData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={11}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '14px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : formattedData.length > 0 ? (
                  <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                    {formattedData?.map((item, index) => (
                      <InsideRowContent item={item} index={index} key={index} fs={'12px'} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
              <Table size="small" aria-label="a dense table" id="table-gbDetailsTableReport-xls" style={{ display: 'none' }}>
                <TableHead style={{ position: `sticky`, top: `0`, background: `white`, borderRadius: '10px 10px 10px 10px' }}>
                  <TableRow>
                    <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '600', textAlign: 'left' }} colSpan={5}>
                      <h3 style={{ paddingLeft: '17px' }}>Report For: Franchise Outstanding Report</h3>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '600', textAlign: 'left' }} colSpan={5}>
                      <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData?.strCompanyName}</h3>
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {excelHeader?.map((item, i) => (
                      <TableCell
                        className="ReportItemHead"
                        style={{ backgroundColor: '#e5f3ff', color: '#444444', fontSize: '12px', fontWeight: '600', textAlign: 'left' }}
                        colSpan={item.colSpan}
                        key={i}
                      >
                        {item.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                      {moment(headerData.fromDate).format('DD/MM/YYYY')}
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                      {moment(headerData.toDate).format('DD/MM/YYYY')}
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                      {headerData?.sourceCity}
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={2}>
                      {headerData?.sourceBranch}
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                      {headerData?.destinationCity}
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={2}>
                      {headerData?.destinationBranch}
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                      {headerData?.paymentType}
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                      {headerData?.reportView}
                    </TableCell>
                  </TableRow>
                  <TableRow className="sammary-heading" style={{ borderRadius: '10px 10px 10px 10px' }}>
                    {updatedPDFHeaderColumns?.map((item, i) => (
                      <TableCell
                        className="userWiseReportHeading"
                        key={i}
                        style={{
                          textAlign: item.align,
                          verticalAlign: 'top',
                          color: tableHeaderColor.textColor,
                          backgroundColor: tableHeaderColor.isHeadingColor,
                          whiteSpace: 'pre-line',
                        }}
                      >
                        {item?.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {formattedData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={11}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '14px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : formattedData.length > 0 ? (
                  <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                    {formattedData?.map((item, index) => (
                      <InsideRowContent item={item} index={index} key={index} fs={'14px'} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
            </>
          </TableContainer>
        </Stack>
      ) : (
        <>
          <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
            {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
            {load ? (
              <object
                id="gbDetailsOutput"
                type="application/pdf"
                width={'100%'}
                height="440"
                title="MTLPL -Cargo System -Franchise Outstanding Report"
                aria-label="MTLPL -Cargo System -Franchise Outstanding Report"
              ></object>
            ) : (
              ''
            )}
          </Box>
        </>
      )}
    </>
  )
}

export default FranchiseOutstandingReportTable
